export default "__VITE_PUBLIC_ASSET__ac9b3288__"